module.exports = window["core-js/modules/es.string.starts-with.js"];